import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import CustomScrollDiv from '../../forecast-app/shared/components/scroll-bars/custom_scroll_div';

class Creatable extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isFocused: false,
			inputValue: '',
			marked: null,
			//merged from 'select_input'
			isInitialRender: true,
			renderOnTop: false,
			dropdownHeight: 0,
		};
	}

	//merged from 'select_input'
	componentDidUpdate(prevProps, prevState) {
		if (!prevState.isFocused && this.state.isFocused) {
			const dropdownNode = this.dropdown.getBoundingClientRect();
			let el = ReactDOM.findDOMNode(this.dropdown).parentNode;
			const windowHeight = window.innerHeight;
			this.setState({
				isInitialRender: false,
				renderOnTop: el.offsetTop > 310 && dropdownNode.bottom - windowHeight > -70, //70 is to not make it end exactly at the bottom but have some space instead
				dropdownHeight: dropdownNode.height,
			});
		}
		if (prevState.isFocused && !this.state.isFocused) {
			this.setState({
				renderOnTop: false,
			});
		}
		if (prevState.inputValue !== this.state.inputValue) {
			if (this.dropdown) {
				const dropdownNode = this.dropdown.getBoundingClientRect();
				this.setState({
					dropdownHeight: dropdownNode.height,
				});
			}
		}
	}

	handleFocus() {
		if (!this.props.locked) {
			this.setState({isFocused: !this.state.isFocused});
			if (this.state.isFocused) {
				this.creatable_input.blur();
				this.setState({isFocused: !this.state.isFocused}); //merged from 'select_input'
			} else {
				this.creatable_input.focus();
			}
		}
	}

	handleBlur(e) {
		if (e.target && e.target.className === 'creatable-wrapper') {
			return;
		}
		this.setState({isFocused: false, marked: null});
		this.creatable_input.blur();
	}

	handleScroll(e) {
		e.preventDefault();
	}

	handleClearInput() {
		this.setState({inputValue: ''});
	}

	handleValueChange(e) {
		this.setState({inputValue: e.target.value, marked: null});
	}

	handleSelect(e, option) {
		if (e) {
			e.preventDefault();
		}

		if (this.props.value) {
			let value = this.props.options.filter(option => {
				return this.props.value.includes(option.value);
			});
			if (this.props.value.includes(option.value)) {
				this.props.removeSelected(option.value);
			} else {
				value.push(option);
				this.props.onChange(value);
			}
		} else {
			const value = [option];
			this.props.onChange(value);
		}
	}

	newOptionClick(e) {
		e.preventDefault();
		if (this.props.disableLabelCreation) {
			return;
		}
		this.props.onNewOptionClick(this.state.inputValue);
		this.setState({inputValue: ''});
	}

	handleMouseOverOption(index) {
		this.setState({marked: index});
	}

	handleMouseLeaveOption() {
		this.setState({marked: null});
	}

	handleKeyPress(e) {
		if (e.keyCode === 27) {
			this.handleBlur(e);
		}
		if (e.keyCode === 13) {
			if (this.state.inputValue !== '') {
				const options = this.props.options.filter(option => {
					return option.label.toLowerCase().indexOf(this.state.inputValue.toLowerCase()) >= 0;
				});
				if (options.length === this.state.marked || (options.length === 0 && this.state.marked === null)) {
					//create new
					this.props.onNewOptionClick(this.state.inputValue);
					this.setState({inputValue: '', marked: null});
				} else {
					if (this.state.marked !== null) {
						this.handleSelect(null, options[this.state.marked]);
					} else {
						this.handleSelect(null, options[0]);
					}
				}
			} else {
				if (this.state.marked !== null) {
					this.handleSelect(null, this.props.options[this.state.marked]);
				}
			}
		} else if (e.keyCode === 38) {
			// up arrow
			if (this.state.isFocused && this.state.marked !== null) {
				if (this.state.marked === 0) {
					if (this.state.renderOnTop) return;
					this.setState({marked: null});
				} else {
					this.setState({marked: this.state.marked - 1});
				}
			}
			if (this.state.renderOnTop) {
				if (this.state.marked === null) {
					this.setState({marked: 0});
				}
			}
		} else if (e.keyCode === 40) {
			// down arrow
			let optionsLength;
			if (this.state.inputValue !== '') {
				// +1 to add new option to the list length
				optionsLength =
					this.props.options.filter(option => {
						return option.label.toLowerCase().indexOf(this.state.inputValue.toLowerCase()) >= 0;
					}).length + 1;
			} else {
				optionsLength = this.props.options.length;
			}
			if (this.state.isFocused && (optionsLength !== this.state.marked + 1 || (optionsLength === 1 && this.state.marked === null))) {
				if (this.state.marked === null) {
					if (this.state.renderOnTop) return;
					this.setState({marked: 0});
				} else {
					this.setState({marked: this.state.marked + 1});
				}
			}
		}
	}

	render() {
		const options =
			this.state.inputValue !== ''
				? this.props.options.filter(option => {
						return option.label.toLowerCase().indexOf(this.state.inputValue.toLowerCase()) >= 0;
				  })
				: this.props.options;
		let includesInput = false;
		if (this.state.inputValue !== '') {
			options.forEach(option => {
				if (option.label.toLowerCase().includes(this.state.inputValue.toLowerCase())) {
					includesInput = true;
				}
			});
		}
		const dropdownStyle = this.state.renderOnTop ? {top: 12 - this.state.dropdownHeight} : {}; //merged from 'select_input'

		return (
			<div className={this.props.locked ? 'creatable-wrapper-locked' : 'creatable-wrapper'} tabIndex="0" onBlur={this.handleBlur.bind(this)}>
				<label className={this.state.isFocused ? 'label-focused' : 'label'}>{this.props.label}</label>
				<div className="input-container">
					<input
						data-cy={this.props.dataCy}
						className={this.state.isFocused ? 'input-focused' : 'input'}
						value={this.state.inputValue}
						onFocus={this.handleFocus.bind(this)}
						disabled={this.props.locked}
						onChange={this.handleValueChange.bind(this)}
						ref={input => {
							this.creatable_input = input;
						}}
						onKeyDown={this.handleKeyPress.bind(this)}
						placeholder={this.props.placeholder}
					/>
					{this.state.inputValue !== '' ? <div className="input-clear-icon" onClick={this.handleClearInput.bind(this)} /> : null}
					<div className={this.state.isFocused ? 'input-icon-expanded' : 'input-icon-collapsed'} onClick={this.handleFocus.bind(this)} />
				</div>
				{this.state.isFocused ? (
					<div
						ref={e => (this.dropdown = e)} //merged from 'select_input'
						style={dropdownStyle} //merged from 'select_input'
						className="select"
						onMouseDown={this.handleScroll.bind(this)}
					>
						<CustomScrollDiv autoHeight={true} autoHeightMin={1} autoHeightMax={300}>
							<div>
								{options.map((option, index) => (
									<div
										data-cy={this.props.optionCy}
										id={'select_option_' + index}
										key={index}
										className={(this.props.value.includes(option.value) ? 'option-selected' : 'option') + (this.state.marked === index ? ' marked' : '')}
										onMouseDown={e => {
											this.handleSelect(e, option);
										}}
										onMouseOver={this.handleMouseOverOption.bind(this, index)}
										onMouseLeave={this.handleMouseLeaveOption.bind(this)}
									>
										<span>{option.label}</span>
									</div>
								))}
								{this.state.inputValue !== '' && !includesInput && !this.props.disableLabelCreation ? (
									<div
										id="select_option"
										className={'option' + (this.state.marked === options.length ? ' marked' : '')}
										onMouseDown={e => {
											this.newOptionClick(e);
										}}
									>
										<FormattedMessage id={this.props.translationId} values={{label: this.state.inputValue}} />
									</div>
								) : (
									<div className={'option' + (this.state.marked === options.length ? ' marked' : '')} content={''} />
								)}
							</div>
						</CustomScrollDiv>
					</div>
				) : null}
			</div>
		);
	}
}

Creatable.propTypes = {
	label: PropTypes.string,
	options: PropTypes.array,
	locked: PropTypes.bool,
	value: PropTypes.array,
	translationId: PropTypes.string.isRequired,
	removeSelected: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
	placeholder: PropTypes.string,
};
export default Creatable;
